// Module
var code = "<div id=\"live-stream-container\">\n\t<live-stream-panel style=\"position:absolute;\" stream=\"stream\" ng-repeat=\"stream in $ctrl.liveStreamService.streams\">\n\t</live-stream-panel>\n</div>\n";
// Exports
module.exports = code;